<button
  (click)="action?.($event)"
  [ngClass]="getDynamicClasses()"
  class="rounded-button-square flex flex-grow content-center justify-center gap-x-3 px-4 py-2 text-center"
  data-cy="square-button">
  @if (icon) {
    <img [src]="icon" [alt]="alt" class="flex h-[20px] w-[20px] self-center" />
  }
  <div
    [ngClass]="text.includes('selected') ? 'font-normal' : 'font-semibold'"
    class="max-w-[250px] overflow-hidden truncate whitespace-nowrap text-sm">
    {{ text }}
  </div>
</button>
